<template>
  <div class="dialog-container wt-dialog-container">
    <div>
      <div class="tab-info-card">
        <div class="user-detail">
          <div class="tab-info-title tab-info-title-flex">
            <span>基本资料</span>
            <el-button type="primary" size="mini" @click="editGarbage">编辑</el-button>
          </div>
          <div class="tab-info-content tab-base">
            <div class="tab-base-item">
              <span class="tab-base-label">账号：</span>
              <span class="tab-base-value">{{ detailFormData.name }}</span>
            </div>
    <!--        <div class="tab-base-item">
              <span class="tab-base-label">账号密码：</span>
              <span class="tab-base-value"></span>
            </div> -->
            <div class="tab-base-item">
              <span class="tab-base-label">用户姓名：</span>
              <span class="tab-base-value">{{ detailFormData.userName }}</span>
            </div>
<!--            <div class="tab-base-item">
              <span class="tab-base-label">省市县：</span>
              <span class="tab-base-value">哈哈</span>
            </div> -->
            <div class="tab-base-item">
              <span class="tab-base-label">社区：</span>
              <span class="tab-base-value">{{ detailFormData.communityName }}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">手机号码：</span>
              <span class="tab-base-value">{{ detailFormData.phone }}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">是否可以投递垃圾：</span>
              <span class="tab-base-value">{{ detailFormData.isHandleDelivery === 1 ? '是' : '否' }}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">是否可以订单核销：</span>
              <span class="tab-base-value">{{ detailFormData.isHandleOrder === 1 ? '是' : '否' }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- tab内容 -->
      <div class="tab-info-card tab-info-padding">
        <el-tabs v-model="activeTabName">
          <el-tab-pane label="居民投递记录" name="first"></el-tab-pane>
          <el-tab-pane label="大客户投递记录" name="second"></el-tab-pane>
          <el-tab-pane label="核销记录" name="third"></el-tab-pane>
        </el-tabs>
        <div v-if="activeTabName === 'first'">
          <wt-form-table key="first" :form.sync="firstForm" ></wt-form-table>
        </div>
        <div v-if="activeTabName === 'second'">
          <wt-form-table key="second" :form.sync="secondForm">
            <wt-form-table-list slot="wtFormTableList" :form.sync="secondForm">
              <template slot="garbageTotalPrice" slot-scope="data">
                <span>{{ $wtUtil.transMoney(data.row.garbageTotalPrice) }}</span>
              </template>
            </wt-form-table-list>
          </wt-form-table>
        </div>
        <div v-if="activeTabName === 'third'">
          <wt-form-table key="third" :form.sync="thirdForm" ></wt-form-table>
        </div>
      </div>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
    <wt-detail-page  :visible.sync="editObj.visible" :component-name="editComponentName" component-type="edit" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'StaffAccountView',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      formCode: 'MODULES_USERMESSAGE',
      isSubmitLoading: false,
      formUpdateUrl: '/modules/userMessage/userMessageUpdate',
      formAddUrl: '/modules/userMessage/userMessageAdd',
      detailFormButtons: {
        title: '用户详情',
        elements: [{ name: '创建', key: 'ADD', action: 'ADD', hidden: this.componentType !== 'add' },
          { name: '保存', key: 'EDIT', action: 'EDIT', hidden: this.componentType !== 'edit' },
          { name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      activeTabName: 'first',
      firstForm: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULES_USERMESSAGE',
        formComponent: {
          list: { type: 'default', value: '/modules/userEmployees/userEmployeesUserDeliveryPageList' }
        },
        formInputsData: [{ name: '搜索用户', key: 'keyWord', value: '', type: 'text' },
          { name: '兑换时间', key: 'updateTimeRange', value: [], type: 'datetime' },
          { name: '类型', key: 'userType', value: 1, type: 'customAllFixed', display: 'more' },
          { name: '用户', key: 'employeesUserId', value: 0, type: 'customAllFixed', display: 'more' }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/userEmployees/userEmployeesUserDeliveryImport',
          fileName: '居民投递记录' }],
        formTableData: [
          { name: '用户昵称', key: 'nickName', type: 'text' },
          { name: '手机号码', key: 'phone', type: 'text' },
          { name: '兑换时间', key: 'createTime', type: 'text', sortable: 'custom' },
          { name: '兑换积分', key: 'garbageTotalPrice', type: 'text' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonHidden: true }
      },
      secondForm: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULES_USERMESSAGE',
        formComponent: {
          list: { type: 'default', value: '/modules/userEmployees/userEmployeesUserDeliveryPageList' }
        },
        formInputsData: [{ name: '搜索用户', key: 'keyWord', value: '', type: 'text' },
          { name: '兑换时间', key: 'updateTimeRange', value: [], type: 'datetime' },
          { name: '类型', key: 'userType', value: 2, type: 'customAllFixed', display: 'more' },
          { name: '用户', key: 'employeesUserId', value: 0, type: 'customAllFixed', display: 'more' }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/userEmployees/userEmployeesUserDeliveryImport',
          fileName: '大客户投递记录' }],
        formTableData: [
          { name: '大客户姓名', key: 'name', type: 'text' },
          { name: '手机号码', key: 'phone', type: 'text' },
          { name: '兑换时间', key: 'createTime', type: 'text', sortable: 'custom' },
          { name: '兑换金额', key: 'garbageTotalPrice', type: 'custom' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonHidden: true }
      },
      thirdForm: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULES_USERMESSAGE',
        formComponent: {
          list: { type: 'default', value: '/modules/userEmployees/userEmployeesExchangePageList' }
        },
        formInputsData: [{ name: '搜索用户', key: 'keyWord', value: '', type: 'text' },
          { name: '核销时间', key: 'updateTimeRange', value: [], type: 'datetime' },
          { name: '用户', key: 'userId', value: 2, type: 'customAllFixed', display: 'more' }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/userEmployees/userEmployeesExchangePageListImport',
          fileName: '核销记录' }],
        formTableData: [
          { name: '订单编号', key: 'orderNumber', type: 'text' },
          { name: '用户昵称', key: 'nickName', type: 'text' },
          { name: '手机号码', key: 'phone', type: 'text' },
          { name: '核销时间', key: 'exchangeTime', type: 'text', sortable: 'custom' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonHidden: true }
      },
      editComponentName: 'UserEmployees-edit',
      editObj: {
        visible: false,
        limit: 1
      }
    }
  },
  created() {
    this.firstForm.formInputsData[3].value = this.detailFormData.id
    this.secondForm.formInputsData[3].value = this.detailFormData.id
    this.thirdForm.formInputsData[2].value = this.detailFormData.id
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      }
    },
    secondBtnsEvents() {

    },
    onButtonAction() {

    },
    editGarbage() {
      this.editObj.visible = true
    },
    /*  ------------------------- 网络请求  -------------------------  */
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    }
  },
  computed: {
    ...mapState({
      detailFormData: state => state.userEmployees.userEmployeesDetailData
    })
  }
}
</script>

<style lang="scss" scoped>
.user-info-card {
  .user-detail {
    background: #fff;
    .user-detail-top {
      display: flex;
      align-items: center;
      padding: 20px;
    }
    .user-detail-photo {
      width: 48px;
      height: 48px;
      border: 1px solid #666;
      border-radius: 50%;
      margin-right: 16px;
    }
    .user-detail-username {
      font-size: 20px;
      font-weight: 500;
      line-height: 20px;
      color: #333;
      margin-right: 16px;
    }
    .user-detail-level {
      padding: 2px 8px;
      font-size: 12px;
      line-height: 14px;
      border: 1px solid rgba(204, 204, 204, 1);
      color: #666;
    }
    .user-detail-bottom {
      display: flex;
      align-items: center;

    }
    .user-detail-label {
      margin-left: 84px;
      color: #989898;
    }
    .user-detail-value {
      color: #666666;
    }
  }
}
.tab-info-title {
  padding: 20px;
  border-bottom: 1px solid rgba(228, 228, 228, 1);
  font-size: 16px;
  font-weight: 600;
  color: #444;
}
.tab-info-card {
  margin-top: 20px;
  background: #fff;

  .tab-base {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .tab-base-item {
      display: flex;
      align-items: center;
      width: 400px;
      margin-bottom: 20px;
    }
    .tab-base-label {
      width: 140px;
      text-align: right;
      color: #989898;
    }
    .tab-base-value {
      color: #666666;
    }
  }
  .tab-info-content {
    padding: 20px;
  }
}
.tab-info-padding {
  padding: 20px;
}
.tab-info-title-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
<style lang="scss">
.user-info-card {
  .el-tabs__header {
    margin-bottom: 0;
    .el-tabs__item.is-active {
      color: #108ee9;
    }
  }
  .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    padding-left: 20px;
  }
  .el-tabs {
    margin-top: 20px;
  }
}
</style>
